import classNames from 'classnames';
import { WIDGET_DRAGGABLE_ITEM_TYPE } from 'constants/widgets';
import React from 'react';
import { useDrop } from 'react-dnd';
import styles from './WidgetDropTarget.module.scss';

interface Props {
  className?: string;
  position: 'bottom' | 'left' | 'right' | 'top' | 'add';
  targetSequence: number;
}

const WidgetDropTarget: React.FC<Props> = ({ className, targetSequence, position }) => {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: WIDGET_DRAGGABLE_ITEM_TYPE,
      collect: monitor => ({
        isOver: monitor.canDrop() && monitor.isOver(),
      }),
      drop: () => ({
        targetSequence,
      }),
    }),
    [targetSequence]
  );

  return (
    <div
      className={classNames(
        styles.widgetDropTarget,
        {
          [styles.isOver]: isOver,
          [styles.bottom]: position === 'bottom',
          [styles.top]: position === 'top',
          [styles.left]: position === 'left',
          [styles.right]: position === 'right',
          [styles.add]: position === 'add',
        },
        className
      )}
      ref={drop}
    >
      <div />
      <div />
      <div />
    </div>
  );
};

export default WidgetDropTarget;
